import { getRouteApi } from '@tanstack/react-router'

const companyRoute = getRouteApi('/_auth/company/$companyId')

export function useJobillaOrgId(): string {
	const { jobillaOrgId } = companyRoute.useRouteContext()
	return jobillaOrgId
}
